import jQuery from 'jquery';

export default function translate() {
    jQuery(() => {
        const $ = jQuery;
        const lang = document.querySelector('html')
            .getAttribute('lang');


        $('.header__toolbar-lang a')
            .on('click', (e) => {
                e.preventDefault();

                const that = e.currentTarget;

                $(that)
                    .next()
                    .toggleClass('visible');
            });


        window.googleTranslateElementInit = function () {
            if (typeof google.translate.TranslateElement === 'function') {
                new google.translate.TranslateElement({
                    pageLanguage: lang,
                }, 'google_translate_element');
            }
        };

        // googleTranslateElementInit();

        window.triggerHtmlEvent = function (element, eventName) {
            let event;
            if (document.createEvent) {
                event = document.createEvent('HTMLEvents');
                event.initEvent(eventName, true, true);
                element.dispatchEvent(event);
            } else {
                event = document.createEventObject();
                event.eventType = eventName;
                element.fireEvent(`on${event.eventType}`, event);
            }
        };

        jQuery('.lang-select')
            .click(function () {
                const theLang = jQuery(this)
                    .attr('data-lang');
                jQuery('.goog-te-combo')
                    .val(theLang);

                window.location = jQuery(this)
                    .attr('href');
                location.reload();
            });
    });
}
